<template>
    <div class="saleoutView">
        <vxe-layout-container vertical>
            <vxe-layout-header>
                <vxe-form :data="formData">
                    <vxe-form-item field="fromdate" title="日期从" span="4">
                        <vxe-date-picker v-model="formData.fromdate" placeholder="请选择开始日期" />
                    </vxe-form-item>
                    <vxe-form-item field="enddate" title="日期到" span="4">
                        <vxe-date-picker v-model="formData.enddate" placeholder="请选择结束日期" />
                    </vxe-form-item>
                    <vxe-form-item field="customer" title="客户名称" span="4">
                        <vxe-input v-model="formData.customer" placeholder="请输入客户名称" clearable class="form-input" />
                    </vxe-form-item>
                    <vxe-form-item span="8">
                        <vxe-button type="submit" status="primary" @click="handleSearch">搜索</vxe-button>
                        <vxe-button status="error" @click="handleAddNew">新增</vxe-button>
                        <vxe-button status="primary" @click="handleCopyAddNew">复制新增</vxe-button>
                    </vxe-form-item>
                </vxe-form>
            </vxe-layout-header>
            <vxe-layout-body>
                <vxe-layout-container>
                    <vxe-layout-aside width="45vw" style="padding: 0 10px">
                        <vxe-table border stripe show-overflow height="100%" :data="tableData" ref="tableref"
                            width="100%" :row-config="{ isCurrent: true, isHover: true }" :loading="loading"
                            :cell-config="{ height: 30 }" @current-row-change="handleChange">
                            <vxe-column type="seq" width="40" title="序号"></vxe-column>

                            <vxe-column field="zjdh" title="单号" width="140"></vxe-column>
                            <vxe-column field="rq" title="日期" width="100">
                                <template #default="{ row }">
                                    {{ row.rq ? new Date(row.rq).toLocaleDateString('zh-CN') : '-' }}
                                </template>
                            </vxe-column> <vxe-column field="khmc" title="客户名称" width="160"></vxe-column>
                            <vxe-column field="lxrh" title="联系电话" width="150">
                               
                            </vxe-column>
                            <vxe-column field="hjje" title="合计金额" width="80" align="right">
                                <template #default="{ row }">
                                    {{ row.hjje ? row.hjje.toFixed(2) : '0.00' }}
                                </template>
                            </vxe-column>
                            <vxe-column field="备注" title="备注" width="100"></vxe-column>
                            <vxe-column title="操作" width="100" fixed="right">
                                <template #default="{ row }">
                                    <vxe-button mode="text" status="warning" @click="handleEdit(row)">编辑</vxe-button>
                                    <vxe-button mode="text" status="danger" @click="handleDelete(row)">删除</vxe-button>

                                </template>
                            </vxe-column>
                        </vxe-table>
                    </vxe-layout-aside>
                    <vxe-layout-body style="padding: 0 10px">
                        <vxe-table border stripe show-overflow height="100%" :data="detailTableData" ref="detailTableRef"
                            width="100%" :row-config="{ isCurrent: true, isHover: true }" :loading="loading" show-footer 
                            :footer-data="footerData"
                            :cell-config="{ height: 30 }">
                            <vxe-column type="seq" width="40" title="序号"></vxe-column>
                            <vxe-column field="lx" title="类型" width="100"></vxe-column>
                            <vxe-column field="mc" title="名称" min-width="160"></vxe-column>
                            <vxe-column field="dj" title="单价" width="100"></vxe-column>
                            <vxe-column field="sl" title="数量" width="80"></vxe-column>
                            <vxe-column field="dw" title="单位" width="80"></vxe-column>
                            <vxe-column field="hj" title="合计" width="100"></vxe-column>
                            <vxe-column field="bz" title="备注" min-width="120"></vxe-column>

                        </vxe-table>
                    </vxe-layout-body>
                </vxe-layout-container>
            </vxe-layout-body>

        </vxe-layout-container>

    </div>
</template>
<script setup>
import { ref, reactive, markRaw, onMounted } from 'vue'
import { VxeUI } from 'vxe-pc-ui'
import dayjs from 'dayjs'
import request from '@/request/request.js'
import axios from 'axios'
import {  CeatrandomUUID, DeleteSaleDoc,CreateNewDocument } from '../utils/saleDocHelper'
import {  sumNum,sumPCBuildRowNum } from '../utils/calculate'
import addPCBuildComp from '@/components/addComp/addPCBuildComp.vue'
import { useTabsStore } from '@/pinia/index'
const loading = ref(false)
const tableData = ref([])
const detailTableData = ref([])
const tableref = ref()
const detailTableRef = ref()
onMounted(async () => {
    await handleSearch()
})
const handleDelete = async (row) => {
    try {
        // 1. 使用 await 等待用户点击确认或取消
        const confirmResult = await VxeUI.modal.confirm({
            title: '删除确认',
            // 2. 使用模板字符串正确显示单号
            content: `确定要删除 ${row.zjdh} 这个装机单吗？`,
            mask: false,
            lockView: false
        });

        // 3. 判断用户是否点击了“确认”（vxe-table 通常返回 'confirm'）
        if (confirmResult === 'confirm') {
            // 4. 执行删除请求
            let res = await request.delete('PCBuild/Delete', { params: { docNum: row.zjdh } });
            if (res.success ) {
                // 5. 删除成功后的操作，例如提示并刷新表格数据
                VxeUI.modal.message({ content: '删除成功', status: 'success' });
                // 这里可以调用你刷新表格列表的方法，例如：fetchTableData()
                handleSearch();
            }
        }
    } catch (error) {
        // 捕获用户点击取消或网络请求报错的情况
        console.log('用户取消了删除操作或请求发生错误', error);
    }
}

// 展开行事件
// ✅ 使用 async/await，自动返回 Promise
const handleChange = async ({ row }) => {
    try {
        const res = await request.get('PCBuild/GetPCBuildDetails', {
            params: {
                docNum: row.zjdh
            }
        })
       
          detailTableData.value = res.data
          updateFootEvent()
       
    } catch (error) {
        alert('加载明细失败:', error)

    }
}
const formData = reactive({
    fromdate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    enddate: dayjs().format('YYYY-MM-DD'),
    customer: '',
})
const handleSearch = async () => {
    try {

        loading.value = true
        const res = await request.post('/PCBuild/GetPCBuildDocs', {
            fromDate: formData.fromdate,
            endDate: formData.enddate,
            customer: formData.customer
        })
       
        tableData.value = res.data
       
        // 调用API搜索
        loading.value = false
    } catch (error) {
        loading.value = false
        VxeUI.modal.message({
            id: 'myUniqueMsg',
            content: error,
            status: 'error'
        })
    }
}
// 在值发生改变时更新表尾合计
const updateFootEvent = () => {
 
    updateFootCount(detailTableData.value)
  
}
const updateFootCount = (list) => {
  const [sumNObj] = footerData.value
  sumNObj.hj = sumNum(list, 'hj')
}
const handleAddNew= () => {
      let AddInstallationOrder= {
      name: CeatrandomUUID(),
      title: '装机单',
      ID: CeatrandomUUID(),
      closable:true,
      component:markRaw(addPCBuildComp),
      props: {
        initialData: {
          usefule: '新增',
          docNumber: CreateNewDocument('ZJD')
        }
      }
    }
    // 添加标签页（如果已存在会自动切换到该标签页）
    const tabsStore = useTabsStore()
    tabsStore.addTab(AddInstallationOrder, true)
    tabsStore.activeTab = AddInstallationOrder.ID
}
const handleCopyAddNew=() => { 
    let $table = tableref.value
     let row = $table.getCurrentRecord()
     let SalesOut = {
        name: CeatrandomUUID,
        title: '装机单',
        ID: CeatrandomUUID(),
        closable: true,
        component: markRaw(addPCBuildComp),
        props: {
            initialData: {
                usefule: '复制新增',
                docNumber: row.zjdh
            }
        }
    }

    // 添加标签页（如果已存在会自动切换到该标签页）
    const tabsStore = useTabsStore()
    tabsStore.addTab(SalesOut, true)
    tabsStore.activeTab = SalesOut.ID
}
const handleEdit = (row) => {
    let SalesOut = {
        name: CeatrandomUUID,
        title: '装机单',
        ID: CeatrandomUUID(),
        closable: true,
        component: markRaw(addPCBuildComp),
        props: {
            initialData: {
                usefule: '修改',
                docNumber: row.zjdh
            }
        }
    }
    // 添加标签页（如果已存在会自动切换到该标签页）
    const tabsStore = useTabsStore()
    tabsStore.addTab(SalesOut, true)
    tabsStore.activeTab = SalesOut.ID
}
const footerData = ref([{ seq: '合计', hj: '0', total: '0' }])
</script>
<style scoped>
.saleoutView {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.table-wrapper {
    flex: 1;
    min-height: 0;
    margin-top: 10px;
}
</style>